import { FC } from "react";
import { CardType } from "../../product-card.types";
import { ProductCard3 } from "../product-card-3";
import { ProductCardProps } from "../../product-card.types";

const ProductCard6: FC<ProductCardProps> = ({
  product,
  withTags,
  cartProducts,
  theme,
  addProduct,
  removeProduct,
  manuallyChangeProduct,
  locale,
  currency,
}) => {
  return (
    <ProductCard3
      product={product}
      withTags={withTags}
      type={CardType.Type6}
      addProduct={addProduct}
      theme={theme}
      cartProducts={cartProducts}
      removeProduct={removeProduct}
      manuallyChangeProduct={manuallyChangeProduct}
      locale={locale}
      currency={currency}
    />
  );
};

export default ProductCard6;
